export const background = {
  default: '#050709',
  subtle: '#0e1113',
}
export const surface = {
  default: '#0e1113',
  raised: '#22272b',
  sunken: '#050709',
}
export const text = {
  default: '#f5f5f5',
  muted: '#cdd3d6',
  subtle: '#888f92',
  inverse: '#050709',
  link: '#8ce0ff',
}
export const border = {
  default: '#353b3f',
  subtle: '#22272b',
  strong: '#888f92',
}
export const action = {
  default: '#26aeff',
  hover: '#8ce0ff',
  subtle: '#001037',
}
export const success = {
  surface: '#001600',
  text: '#8fc78a',
  border: '#005a02',
  solid: '#399936',
}
export const warning = {
  surface: '#270400',
  text: '#eea88a',
  border: '#882f03',
  solid: '#d36734',
}
export const danger = {
  surface: '#230002',
  text: '#ea9294',
  border: '#7c061f',
  solid: '#c63f4e',
}
export const info = {
  surface: '#02071c',
  text: '#8098c2',
  border: '#193366',
  solid: '#4264a4',
}
